import { HttpService } from "./http.service";
import { ResultRequestModel } from "../models/resultRequest.model";

const basePath = "/BdpVersion";
const request = HttpService.handleRequest();

export const BdpVersionService = {
  getVersion
};

async function getVersion(): Promise<ResultRequestModel> {

  return request.get(`${basePath}/GetVersion`);
}

export default BdpVersionService;